import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CircleEmptyIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8 0.5C3.59866 0.5 0.5 3.54865 0.5 7.75384V8.24611C0.5 12.4502 3.59866 15.5 8 15.5C12.4013 15.5 15.5 12.4513 15.5 8.24611V7.75384C15.5 3.54974 12.4013 0.5 8 0.5ZM13.625 8.24628C13.625 11.4634 11.3646 13.625 8 13.625C4.63544 13.625 2.375 11.4634 2.375 8.24628V7.75373C2.375 4.53657 4.63544 2.37501 8 2.37501C11.3646 2.37501 13.625 4.53657 13.625 7.75373V8.24628Z" })));
};

export { CircleEmptyIcon };
//# sourceMappingURL=CircleEmptyIcon.esm.js.map
